import { NotificationQueueItem, NotificationType } from './types';

let notificationId = 1;

export function makeNotification(
  type: string | NotificationType,
  queueName: string,
  params: any
): NotificationQueueItem {
  if (params && params.hasOwnProperty('id')) {
    const { id, ...rest } = params;
    return { id, queueName, type, created: Date.now(), params: rest };
  }
  return {
    id: notificationId++,
    queueName,
    type,
    created: Date.now(),
    params,
  };
}
